import React from 'react';
import { useFirebase } from '../../providers/FirebaseProvider';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
    const { isUserSignedIn } = useFirebase();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center text-white">
            <div className="w-full max-w-md p-8 bg-white bg-opacity-30 backdrop-filter backdrop-blur-lg rounded-3xl shadow-lg transform transition duration-500 hover:scale-105">
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-bold text-gray-800">ECG Notes</h1>
                </div>
                <div className="text-center">
                    {isUserSignedIn() ? (
                        <button
                            className="w-full py-3 text-lg font-medium text-indigo-700 bg-white rounded-full shadow-md hover:bg-gray-200 transition duration-300 transform hover:scale-105"
                            onClick={() => navigate('/projects')}
                        >
                            Go to Projects
                        </button>
                    ) : (
                        <button
                            className="w-full py-3 text-lg font-medium text-indigo-700 bg-white rounded-full shadow-md hover:bg-gray-200 transition duration-300 transform hover:scale-105"
                            onClick={() => navigate('/auth')}
                        >
                            Sign In
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Home;